import React, {memo} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {hideModal} from '@/actions/modalActions';
import NumpadModal from '@/components/numpad/NumpadModal';
import {getMainNumpadModal} from '@/selectors/modalSelector';

function MainNumpadModal() {
  const dispatch = useDispatch();
  const {
    modalVisible,
    modalHeader,
    modalTitle,
    value,
    callback,
    incrementValue,
    minValue,
    maxValue,
    maxDigitAfterDecimal,
    validatorInput,
    numpadMode,
    unit,
    info,
  } = useSelector(getMainNumpadModal);

  const handleonHideModal = () => {
    dispatch(hideModal());
  };

  return (
    <NumpadModal
      modalVisible={modalVisible}
      modalHeader={modalHeader}
      modalTitle={modalTitle}
      value={value}
      callback={callback}
      incrementValue={incrementValue}
      minValue={minValue}
      maxValue={maxValue}
      maxDigitAfterDecimal={maxDigitAfterDecimal}
      validatorInput={validatorInput}
      numpadMode={numpadMode}
      unit={unit}
      info={info}
      onHideModal={handleonHideModal}
    />
  );
}

export default memo(MainNumpadModal);
